import * as React from 'react';

const LinkedIn = ({ fill = '#fff', size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <path
      d="M29.512 0H2.488A2.496 2.496 0 000 2.488v27.024A2.496 2.496 0 002.488 32h27.024A2.496 2.496 0 0032 29.512V2.488A2.48 2.48 0 0029.512 0zM9.505 27.247H4.778V12.068h4.727v15.18zM7.142 10.202A2.846 2.846 0 014.28 7.341a2.846 2.846 0 012.862-2.862 2.846 2.846 0 012.861 2.862 2.878 2.878 0 01-2.861 2.861zm20.155 17.045h-4.728c0-8.61.597-11.446-2.463-11.446-2.837 0-2.887 3.185-2.887 3.384V27.247h-4.728V12.068h4.728v1.892s.846-1.145 1.692-1.643c.846-.497 1.369-.647 3.31-.647 1.841 0 3.235.722 4.205 2.439 1.195 2.09.871 3.882.871 13.138z"
      fill={fill}
    />
  </svg>
);

export default React.memo(LinkedIn);
